import { Text } from 'designSystem/components/Text'
import type { FC, ReactNode } from 'react'

export const SectionTitle: FC<{ children: ReactNode }> = ({ children }) => (
  <Text as='div' variant='caption' color='muted'>
    {children}
  </Text>
)
